import React, {
    useEffect,
    useRef,
    useState,
} from "react";
import PropTypes from "prop-types";
import RecordSourceInstanceGrid
    from "../recordsourceinstancegrid/RecordSourceInstanceGrid";
import { RecordSourcePluginView } from "../recordsourcepluginview/RecordSourcePluginView";
import LoadObject from "data/LoadObject";
import useFluxStore from "@armus/use-flux-store";
import BrowserStore from "data/BrowserStore";

// todo: this is search form and results?!
export function SearchForm(props) {
    const {
        fluxContext,
        fields,
        resultsLO,
        typeOptions,
        onSelectSource,
        onSearch,
        onSelectSourceRecord,
        resultLabeler,
        hasPagination,
        pagination,
        onPage,
    } = props;

    const formRef = useRef();
    const [ resultMaxHeight, setResultMaxHeight ] = useState("80px");
    useEffect(() => {
        const boundingElement = document.querySelector("#modal .modal-body"); // todo: this is silly
        if (!boundingElement) return;
        const boundingRect = boundingElement.getBoundingClientRect();
        const availableHeight = boundingRect.height;
        if (availableHeight === 0) return; // thanks marionette
        setResultMaxHeight(Math.max(
            80, // always want this much
            availableHeight +
            -formRef.current.getBoundingClientRect().height + // form
            -55, // pull
        ) + "px");
    });
    useFluxStore(
        () => setResultMaxHeight("auto"), // force rerender
        [ BrowserStore ],
    );

    return <React.Fragment>
        <div
            className="search-form-layout"
            ref={formRef}
        >
            <RecordSourcePluginView
                typeOptions={typeOptions}
                fluxContext={fluxContext}
                fields={fields}
                onTypeChange={onSelectSource}
                onSubmit={onSearch}
            />
        </div>
        <div className="row">
            <div className="col-md-12">
                {resultsLO.hasValue() && <RecordSourceInstanceGrid
                    resultLabeler={resultLabeler}
                    results={resultsLO.getRequiredValue()}
                    onSelectModel={onSelectSourceRecord}
                    maxHeight={resultMaxHeight}
                    hasPagination={hasPagination}
                    pagination={pagination}
                    onPage={onPage}
                />}
            </div>
        </div>
    </React.Fragment>;
}

SearchForm.propTypes = {
    resultsLO: PropTypes.instanceOf(LoadObject), // w/ Array<EntityProxy> inside
    typeOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    onSelectSource: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onSelectSourceRecord: PropTypes.func.isRequired,
    resultLabeler: PropTypes.func.isRequired,
    fluxContext: PropTypes.string,
    fields: PropTypes.array,
    onPage: PropTypes.func,
    hasPagination: PropTypes.bool,
    pagination: PropTypes.any,
};



// WEBPACK FOOTER //
// ./app/lib/mapping/views/searchform/SearchForm.js